module.exports = __webpack_public_path__ + "static/media/Corteva_How_the_world_grows_TMT-CORT003-120-mobile.2aebf397.jpg";